{
  "removeButtonLabel": "Ukloni",
  "removeDescription": "Pritisnite Obriši da biste uklonili oznaku."
}
